<template>
    <div class="forwhats-wrapper">
      <div class="header-row">
        <span class="section-title">Tokens privados</span>
        <button class="btn" @click="showModal = true">Novo token</button>
      </div>
  
      <div class="token-list">
        <div
          v-for="token in tokens"
          :key="token.id"
          class="token-item"
        >
          <input
            type="text"
            :value="token.name"
            readonly
            class="token-input"
          />
          <Trash
            class="delete-icon"
            :size="18"
            @click.native="handleShowDeleteModal(token.id)"
          />
        </div>

        <div v-if="tokens.length === 0" class="empty-state">
          <p class="empty-title">{{ __('Você não possui nenhum token privado.') }}</p>
        </div>
      </div>
  
      <p class="helper-text">
        {{ __('Dúvida em como gerar o token?') }}
        <a
            :href="'https://salesflowcrm.movidesk.com/kb/pt-br/article/522413/como-integrar-o-forwhats-com-o-salesflow'"
            target="_blank"
            rel="noopener noreferrer"
        >
            {{ __('Saiba mais') }}
        </a>
      </p>
  
      <ModalCreateToken
        v-if="showModal"
        @close="showModal = false"
        @created="loadTokens"
      />
      <ModalDeleteToken
        :show="showDeleteModal"
        :deleting="deleting"
        @on:delete="deleteToken"
        @on:close="showDeleteModal = false"
      />
    </div>
  </template>
  
  <script>
  import ModalCreateToken from '../ModalCreateToken.vue'
  import Trash from '../icon/Trash.vue'
  
  export default {
    name: 'IntegrationForWhats',
  
    components: {
      ModalCreateToken,
      Trash
    },
  
    data() {
      return {
        tokens: [],
        tokenToDelete: null,
        showModal: false,
        showDeleteModal: false,
        deleting: false,
      }
    },
  
    created() {
      this.loadTokens()
    },
  
    methods: {
      async loadTokens() {
        try {
          const response = await this.$http.get('/oauth/forwhats/personal-access-tokens')
          this.tokens = response.data
        } catch (error) {
          console.error('Erro ao carregar tokens', error)
        }
      },

      handleShowDeleteModal(id) {
        this.tokenToDelete = id
        this.showDeleteModal = true
      },
  
      async deleteToken() {
        this.deleting = true;
        try {
          await this.$http.delete(`/oauth/forwhats/personal-access-tokens/${this.tokenToDelete}`)
          Alert.success(this.__('Token removido com sucesso'))
          this.loadTokens()
        } catch (error) {
          console.error('Erro ao excluir token', error)
        } finally {
          this.deleting = false
          this.showDeleteModal = false
          this.tokenToDelete = null
        }
      }
    }
  }
  </script>
  
  <style scoped>
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600&display=swap');
  
  .forwhats-wrapper {
    max-width: 640px;
    margin: 0 auto;
    padding: 24px;
    font-family: 'Montserrat', sans-serif;
  }
  
  .header-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
  }
  
  .section-title {
    font-weight: 500;
    font-size: 16px;
    line-height: 150%;
    display: flex;
    align-items: center;
    width: 131px;
    height: 24px;
  }
  
  .btn {
    all: unset;
    font-family: 'Montserrat', sans-serif;
    font-weight: 600;
    font-size: 12px;
    line-height: 150%;
    cursor: pointer;
    padding: 4px 8px;
  }

  .btn:hover {
    text-decoration: underline;
  }
  
  .token-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  
  .token-item {
    display: flex;
    align-items: center;
    padding: 8px;
    border-radius: 6px;
    border: 1px solid #cbd5e1;
    background: #ffffff;
  }
  
  .token-input {
    flex: 1;
    padding: 8px;
    border: none;
    background: transparent;
    font-size: 14px;
    color: #1a1a1a;
  }
  
  .token-input:focus {
    outline: none;
  }
  
  .delete-icon {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #000;
    width: 18px;
    height: 18px;
  }
  
  .helper-text {
    width: 400px;
    height: 18px;
    font-family: 'Montserrat', sans-serif;
    font-weight: 400;
    font-size: 12px;
    line-height: 150%;
    margin-top: 16px;
    color: #1a1a1a;
  }
  
  .helper-text a {
    color: #1a1a1a;
    text-decoration: underline;
    cursor: pointer;
    font-weight: 600;
    display: inline;
  }

  .empty-state {
    font-size: 12px;
    margin-top: 8px;
  }

  </style>
  